exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading.center-please.size-64 {\n  text-align: center;\n  position: relative;\n  left: calc(50% - 32px);\n  top: 32px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/loading/styles.css
// module id = 1719
// module chunks = 29